import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkAuth, getContacts, processContact } from "../services/api";

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [adminUser, setAdminUser] = useState(null);
  const [contacts, setContacts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdminAndContacts = async () => {
      try {
        const response = await checkAuth();
        setAdminUser(response.data.user);

        const contactsResponse = await getContacts();
        setContacts(contactsResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    fetchAdminAndContacts();
  }, [navigate]);

  const toggleContactStatus = async (id, currentStatus) => {
    try {
      await processContact(id, { is_processed: !currentStatus });
      setContacts((prev) =>
        prev.map((c) =>
          c.id === id ? { ...c, is_processed: !currentStatus } : c
        )
      );
      alert("Cập nhật trạng thái thành công!");
    } catch (error) {
      console.error("Lỗi cập nhật trạng thái:", error);
      alert("Không thể cập nhật trạng thái");
    }
  };

  const formatVietnamTime = (isoString) => {
  const date = new Date(isoString);
  // GMT+7 là cộng thêm 7 tiếng (7 * 60 * 60 * 1000)
  const vietnamTime = new Date(date.getTime() + 7 * 60 * 60 * 1000);

  return vietnamTime.toLocaleString("vi-VN");
};

  if (loading)
    return <div className="text-center mt-8">Loading dashboard...</div>;

  return (
    <div className="container max-w-7xl mx-auto px-4 py-8">
      {/* Welcome */}
      {adminUser && (
        <div className="mb-8 p-4 bg-green-100 rounded text-green-800 flex justify-center items-center">
          Admin Dashboard{" "}
          <strong className="ml-2">
            {adminUser.name || adminUser.username}
          </strong>
        </div>
      )}

      {/* Contacts Table */}
      <div className="bg-white rounded-lg shadow-md p-6 overflow-x-auto">
        <h3 className="text-xl font-semibold mb-4">Danh sách liên hệ</h3>

        {contacts.length === 0 ? (
          <p>Chưa có liên hệ nào.</p>
        ) : (
          <table className="min-w-full table-auto border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Tên
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Email
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Điện thoại
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Địa chỉ
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Tin nhắn
                </th>
                <th className="border border-gray-300 px-4 py-2 text-center">
                  Trạng thái
                </th>
                <th className="border border-gray-300 px-4 py-2 text-center">
                  Ngày gửi
                </th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((c) => (
                <tr key={c.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">{c.name}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {c.email}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {c.phone}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {c.address}
                  </td>
                  <td
                    className="border border-gray-300 px-4 py-2 max-w-xs truncate"
                    title={c.message}
                  >
                    {c.message}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    <button
                      onClick={() => toggleContactStatus(c.id, c.is_processed)}
                      className={`px-2 py-1 text-xs font-semibold rounded-full transition
      ${
        c.is_processed
          ? "bg-green-200 text-green-800 hover:bg-green-300"
          : "bg-red-200 text-red-800 hover:bg-red-300"
      }`}
                    >
                      {c.is_processed ? "Đã liên hệ" : "Chưa liên hệ"}
                    </button>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {formatVietnamTime(c.created_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
